import * as React from 'react';

import {useHistory} from 'react-router-dom';

import {AreaPageContext} from '@app/components/Pages/Area/Area';

const AreaHeader = (props) => {
	const history = useHistory();
	const {area} = props;
	const currentAreaUrl = React.useContext(AreaPageContext);
	const openForm = () => {
		history.push(`${currentAreaUrl}/request-info`);
	};
	
	return (
		<header className="area__header">
			<h1 className="area__title">{area.name}</h1>
			<section className="area__btns">
				<button 
					className="btn btn-primary area__btn-wide" 
					type="button" 
					title="Schedule Appointment" 
					onClick = {openForm}
				>
					Schedule Appointment
				</button>
				<a
					className="btn btn-secondary"
					title="Request more info"
					type="button"
					href={`tel:${area.phoneNumber}`}
				>
					<img src={require('@app/images/phone.svg')} alt="phone-icon"/>
					{area.phoneNumber}
				</a>
				{
					area.secondPhoneNumber &&
					<a className="btn btn-secondary" type="button" title="Request more info" href={`tel:${area.secondPhoneNumber}`}>
						<img src={require('@app/images/phone.svg')} alt="phone-icon"/>
						{area.secondPhoneNumber}
					</a>
				}
			</section>
		</header>
	);
};

export default AreaHeader;
